import React from 'react'
import { useState } from 'react';
import {Card} from 'react-bootstrap'
import { isMobileOnly } from 'react-device-detect';
import ImageCanvas from './CoverImage/ImageCanvas';
import Spinner from '../common/Spinner';

const ThreeDBanner = () => {
	const [isLoading, setIsLoading] = useState(true)
  return (
      	<>
			<Card className="three-D-banner no-border rounded-0">
				{isMobileOnly && 
					<div className="movile-version d-sm-block d-md-none">
						<video className='book-sequence-player' muted loop autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
							<source src={process.env.PUBLIC_URL + "assets/books/sequence-video/sequence-books-leaves.mp4"} type="video/mp4"/>
						</video>
					</div>
				}

				{!isMobileOnly &&
					<div className="desktop-version d-none d-md-block">							
						<div style={{display: (isLoading===true) ? 'block' : 'none'}} >
							<Spinner  />
						</div>
						<ImageCanvas scrollHeight={4300} width={window.innerWidth} height={window.innerHeight} numFrames={186} setIsLoading={setIsLoading} />
						
					</div>
				}
			</Card>
      	</>
  )
}

export default ThreeDBanner
